import directoriesService from '../services/directoriesService.js';
import _ from 'lodash';
import dataModel from '../models/DataModel';
import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import ReduxConstants, { RecordStates } from '../constants/ReduxConstants.js';

export const directory_root = {
  directory: { additionalFields: ['logo'] }, vendor_users: {}, vendor_directories: { additionalFields: ['is_vendor_directory'] },
};

export default class DirectoriesDAO extends DAO {

  constructor(store) {
    super(store, 'directory');

    for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (this[name] instanceof Function){
        this[name] = this[name].bind(this);
      }
    }
  }

  unsetDirectory(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearDirectories() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getDirectory(directoryId, options, prefetchCallback) {
    return this._getItem(directoryId, directoriesService.getDirectory.bind(this, directoryId, options), options,
      null, null, prefetchCallback);
  }

  get adminDirectory() {
    let ac = this.stateTree.new_directories.adminDirectory;
    if (ac) {
      return this.mapToReturn(ac, { directory: { directories: { users: {} } } });
    }
  }

  getAdminDirectory(options) {
    return directoriesService.getAdminDirectory(options).then(response => {
      if (!response.error && !response.offline) {
        const storeItem = this.normalizeAndSyncToStore(response, { store: true });
        return Promise.resolve(this.mapToReturn(storeItem, options));
      }
    });
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_directories, options.toIgnore.directories, this.unsetDirectory, this.clearDirectories, options);
  }

  handleResponse(directory, response, dontQueue, options, errorMessage) {
    if (response.offline && dontQueue) {
      return response;    
    }
    else if (response.offline) {
      this.throwItemError();
    }
    else if (response.error) {
      dataModel.displayHTTPError(errorMessage, response.error, false);
      this.markError(directory);
      this.throwItemError();
    }
    else {
      this.normalizeAndSyncToStore(response, options);
      return this.mapToReturn(this.findItem(response.data.id), options);
    }
  }

  createDirectory(directory, options) {
    return directoriesService.createDirectory(directory, null, options).then(response => {
      return this.handleResponse(directory, response, false, options, 'Creating a directory');
    });
  }

  updateDirectory(directory, options) {
    return directoriesService.updateDirectory(directory, null, options).then(response => {
      return this.handleResponse(directory, response, false, options, 'Updating a directory');
    });
  }

  deleteDirectory(directory) {
    this.markDeleted(directory);
    return directoriesService.deleteDirectory(directory.id).then(response => {
      return response;
    });
  }

  checkDirectoriesCollections(directory_id) {
    let collectionIds = dataModel.collectionsDAO.getCollectionsByType(ReduxConstants.DIRECTORY);
    for (let collectionId of collectionIds) {
      let collection = dataModel.collectionsDAO.findCollection(collectionId);

      if (collection && !collection.ids.find(id => {return id == directory_id;})){
        collection._recordState = RecordStates.NEEDS_SYNC;
        dataModel.collectionsDAO.setCollection(collectionId, collection, ReduxConstants.DIRECTORY);
      }
    }
  }

  handleActionCableAndGetRequest(acData) {    
    let directory = this.findItem(acData.directory_id);
    if (directory) {
      if (acData.is_attribute_update) {
        this.markNeedsAttributeSync(directory);
      }
      else {
        this.markNeedsSync(directory);
      }
    }
    this.checkDirectoriesCollections(acData.directory_id);
    switch (acData.type) {
    case 'newDirectory':
    case 'updateDirectory':
    case 'deleteDirectory':
      this.unsetDirectory(acData.directory_id);
      return directory;
    default:
    }

  }

}



// WEBPACK FOOTER //
// ./src/dao/DirectoriesDAO.js